import React, { useState, useEffect, useRef } from "react";
import { Divider } from "@material-ui/core";
import moment from "moment";

import Table from "../../components/Table";
import { Card, CardContent, CardActions } from "../../components/Card";
import Text from "../../components/Text";
import Button from "../../components/Button";
import PageItem from "../../components/PageItem";

export default function ObjErrorReportTable() {
  const [newData, setNewData] = useState({
    page: 1,
    pageMax: null,
    pageSize: 10,
    pageArray: [],
    data: [],
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  return (
    <Card>
      <CardContent>
        
      </CardContent>
      <CardActions>
        <PageItem
          data={newData.pageArray}
          page={newData.page}
          onChangePage={(e) => changeData("page", e, true)}
        />
      </CardActions>
    </Card>
  );
}